var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:[_vm.$style.switch, {[_vm.$style.disabled]: _vm.disabled}]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":(value) => _vm.$emit('change', value.target.checked)}}),_c('span',{class:[_vm.$style.slider,{[_vm.$style.rounded]: _vm.rounded}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }